/**
 * for multi image display
 * @since 2020-09-13 15:50:21
 */

import React, { FC, useState, useEffect, useMemo, useCallback, memo } from 'react';
import classnames from 'classnames';
import { noop } from '@@/utils';
import styles from './index.module.less';
import { Img } from '../img';
import { IconBtn } from '../icon-btn';

interface GalleryProps {
  data: string[] | string;
}

export const Gallery: FC<GalleryProps> = memo(({ data }) => {
  const [state, setState] = useState({
    index: 0,
    sources: [] as string[],
  });

  useEffect(() => {
    setState({
      index: 0,
      sources: Array.isArray(data) ? data : [data],
    });
  }, [data]);

  const currentImage = useMemo(() => state.sources[state.index], [state]);

  const changePage = useCallback(
    (reducer: (prev: number) => number) => () => {
      setState(prev => {
        const reducedIndex = reducer(prev.index);
        const targetIndex =
          reducedIndex < 0 ? prev.sources.length - 1 : reducedIndex > prev.sources.length - 1 ? 0 : reducedIndex;
        return {
          ...prev,
          index: targetIndex,
        };
      });
    },
    []
  );

  return (
    <div className={styles.gallery}>
      <div className={styles.major}>
        <Img className={styles['major-image']} alt="main" src={currentImage} />
        <IconBtn
          className={classnames(styles.btn, styles['btn--left'])}
          onClick={changePage(prev => prev - 1)}
          type="left-arrow"
        />
        <IconBtn
          className={classnames(styles.btn, styles['btn--right'])}
          onClick={changePage(prev => prev + 1)}
          type="right-arrow"
        />
      </div>
      <footer className={styles.footer}>
        {state.sources.map((src, index) => {
          const isCurrent = index === state.index;
          return (
            <div
              className={classnames({
                [styles.thumbnail]: true,
                [styles['thumbnail--current']]: isCurrent,
              })}
              key={index}
              onClick={isCurrent ? noop : () => setState(prev => ({ ...prev, index }))}
            >
              <Img className={styles['thumbnail-image']} src={src} alt="thumbnail" />
            </div>
          );
        })}
      </footer>
    </div>
  );
});
